import { upgradeAdapter } from '../../upgrade_adapter';
import { Dashboard } from './dashboard/dashboard.component';
import { Fullscreen } from './fullscreen/fullscreen.component.ts';

module.exports = function(ngModule) {
    ngModule.directive('dashboard', upgradeAdapter.downgradeNg2Component(Dashboard))
    ngModule.directive('fullscreen', upgradeAdapter.downgradeNg2Component(Fullscreen))
}


/** WEBPACK FOOTER **
 ** ./src/landing/directives/index.ts
 **/